import { render, staticRenderFns } from "./BasicPage.vue?vue&type=template&id=6e27d880&"
import script from "./BasicPage.vue?vue&type=script&lang=js&"
export * from "./BasicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports